module.exports = __webpack_public_path__ + "static/media/search.1844f8a0.svg";